export default [
  { label: 'DD/MM/YY', value: 'en-UK' },
  { label: 'MM/DD/YY', value: 'en-US' },
]
